const CORP_SUFFIX = /\b(CO|LTD|INC|CORP|CORPORATION|COMPANY|LLC|GMBH|LIMITED)\b|주식회사|\(주\)|㈜/g;

/** 전각 영숫자·기호를 반각으로 맞춘다. 같은 품목이 전각 표기 때문에 갈리지 않게 하기 위함. */
export function toHalfWidth(value = '') {
    return String(value).replace(/[！-～]/g, (ch) => String.fromCharCode(ch.charCodeAt(0) - 0xfee0));
}

/** 당사자명 비교용 정규화. 대문자·법인격 표기·구두점·공백을 걷어내고 뼈대만 남긴다. */
export function normalizeParty(name = '') {
    return toHalfWidth(name).toUpperCase().replace(CORP_SUFFIX, '').replace(/[^A-Z0-9가-힣]/g, '');
}

/** House 당사자와 PL 기재값이 같은 회사로 볼 수 있는지. 별칭에 등록된 표기도 일치로 본다. */
export function isSameParty(houseName, plName, aliases = []) {
    if (!plName) return true;
    const target = normalizeParty(plName);
    if (target === normalizeParty(houseName)) return true;
    return aliases.some((alias) => normalizeParty(alias) === target);
}

/** 집계 키 미리보기. 확정 시 백엔드가 같은 규칙으로 만들지만 화면에서 중복 라인을 짚어주기 위해 둔다. */
export function previewItemKey(line) {
    const source = line.barcode || line.buyer_sku || line.item_code || line.description || '';
    return toHalfWidth(source).toUpperCase().replace(/[^A-Z0-9가-힣]/g, '');
}

/** 수량 단위 표기를 마스터 코드로 바꾼다. 못 찾으면 null을 돌려 사용자가 고르게 한다. */
export function resolveUom(raw, master, aliases) {
    if (!raw) return null;
    const key = toHalfWidth(raw).trim().toUpperCase();
    if (master.includes(key)) return key;
    return aliases[key] ?? null;
}
